export const PUBLIC_VERIFICATION_RESULT_KEY = "publicVerificationResult";

let memoryUploadPreview = null;

export const readUploadPreview = () => {
  if (memoryUploadPreview?.document) {
    return memoryUploadPreview;
  }
  return null;
};

export const writeUploadPreview = (upload) => {
  if (!upload?.document) {
    clearUploadPreview();
    return;
  }

  memoryUploadPreview = {
    document: upload.document,
    fileName: upload.fileName || null,
    fileType: upload.fileType || null,
  };
};

export const clearUploadPreview = () => {
  memoryUploadPreview = null;
};

export const clearPublicVerificationSession = () => {
  clearUploadPreview();
  sessionStorage.removeItem(PUBLIC_VERIFICATION_RESULT_KEY);
};
